var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 = _vm.__map(_vm.bill, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var m0 = index < 10 ? _vm.rturnObjec(item) : null
    return {
      $orig: $orig,
      m0: m0,
    }
  })
  var g0 = _vm.bill.length
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
        g0: g0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }